import { Field } from "sparkson";

export class Part {
  constructor(
    @Field("id") public id: number,
    @Field("s") public size: number,
  ) {}
}
